// extracted by mini-css-extract-plugin
module.exports = {"fieldWithIcon":"FieldIcon_fieldWithIcon__18GE2","iconWrapper":"FieldIcon_iconWrapper__3kmJC","icon":"FieldIcon_icon__2d4tz"};